import { IconArrowBack } from '@tabler/icons-react';

import { AppShell, Box, Burger, Button, Group, Skeleton, Transition } from '@optiro/ui';

import AccountSettings from '@/components/AccountSettings/AccountSettings';
import { CompanyStatusIndicator } from '@/components/CompanyStatusIndicator';
import { Notifications } from '@/components/Notifications';
import { useHeaderLeftSlotStore } from '@/stores/headerLeftSlotStore';
import type { userData as UserData } from '@/types/types';

import { HeaderToolbarSlot } from './HeaderToolbarSlot';

export interface AppHeaderViewProps {
  opened: boolean;
  onToggle: () => void;
  onBack: () => void;
  userData: UserData | null;
}

export const AppHeaderView = ({ opened, onToggle, onBack, userData }: AppHeaderViewProps) => {
  const leftSlotContent = useHeaderLeftSlotStore((state) => state.content);

  return (
    <AppShell.Header
      style={{
        zIndex: 50,
        backgroundColor: 'rgba(255, 255, 255, 0.79)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Group
        align="center"
        w="100%"
        style={{ height: 50, maxWidth: 1400, marginLeft: 'auto', marginRight: 'auto' }}
      >
        <Burger opened={opened} onClick={onToggle} hiddenFrom="sm" size="sm" />
        <Group justify="space-between" flex={1} align="center" px="sm">
          <Group gap="xs" wrap="nowrap">
            <Box style={{ position: 'relative' }}>
              <Transition
                mounted={!!leftSlotContent}
                transition="slide-down"
                duration={200}
                timingFunction="ease"
              >
                {(styles) => <div style={styles}>{leftSlotContent}</div>}
              </Transition>
              {!leftSlotContent && (
                <Button
                  variant="subtle"
                  size="xs"
                  visibleFrom="sm"
                  leftSection={<IconArrowBack stroke={1.2} size={18} />}
                  onClick={onBack}
                >
                  Tilbage
                </Button>
              )}
            </Box>
            <HeaderToolbarSlot />
          </Group>
          <Group align="center" justify="flex-end" gap={'sm'}>
            <CompanyStatusIndicator />
            <Notifications />
            {userData ? (
              <AccountSettings userData={userData} />
            ) : (
              <Skeleton height={32} width={150} radius="sm" />
            )}
          </Group>
        </Group>
      </Group>
    </AppShell.Header>
  );
};
